import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=4be00288"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=4be00288&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports